// Mock data for Reverential Consultants LLP website

export const heroData = {
  headline: "Scalable Cloud Infrastructure for Modern Businesses",
  subheadline: "Enterprise-grade cloud solutions delivering unmatched reliability, performance, and global reach for your digital transformation journey",
  ctaPrimary: "Get Started",
  ctaSecondary: "Request Consultation",
  heroImage: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxkYXRhY2VudGVyfGVufDB8fHx8MTc3NzUyNDUyNHww&ixlib=rb-4.1.0&q=85"
};

export const trustIndicators = [
  { label: "Uptime SLA", value: "99.99%" },
  { label: "24/7 Support", value: "Always On" },
  { label: "Data Centers", value: "15+" }
];

export const servicesData = [
  {
    id: 1,
    title: "Cloud Infrastructure Solutions",
    description: "Build and scale your infrastructure with enterprise-grade cloud architecture designed for performance, reliability, and cost optimization.",
    image: "https://images.unsplash.com/photo-1667984390538-3dea7a3fe33d",
    features: ["Auto-scaling infrastructure", "Multi-cloud deployment", "Cost optimization", "High availability architecture"]
  },
  {
    id: 2,
    title: "Managed Hosting Services",
    description: "Focus on your business while we handle your hosting infrastructure with 24/7 monitoring, maintenance, and expert support.",
    image: "https://images.pexels.com/photos/17489152/pexels-photo-17489152.jpeg",
    features: ["24/7 monitoring", "Automated backups", "Performance tuning", "Security patches"]
  },
  {
    id: 3,
    title: "Network Architecture & Optimization",
    description: "Design and optimize your network infrastructure for maximum performance, security, and reliability across global deployments.",
    image: "https://images.unsplash.com/photo-1683322499436-f4383dd59f5a",
    features: ["Network design", "Load balancing", "CDN integration", "Latency optimization"]
  },
  {
    id: 4,
    title: "DevOps & Deployment Automation",
    description: "Accelerate your development lifecycle with automated CI/CD pipelines, infrastructure as code, and continuous deployment strategies.",
    image: "https://images.unsplash.com/photo-1573757056004-065ad36e2cf4",
    features: ["CI/CD pipelines", "Infrastructure as Code", "Container orchestration", "Automated testing"]
  },
  {
    id: 5,
    title: "Security & Compliance",
    description: "Protect your infrastructure with comprehensive security solutions, compliance management, and threat detection systems.",
    image: "https://images.pexels.com/photos/5475793/pexels-photo-5475793.jpeg",
    features: ["Security audits", "Compliance management", "Threat detection", "Data encryption"]
  }
];

export const solutionsData = [
  {
    id: 1,
    title: "For Startups",
    description: "Fast, scalable infrastructure that grows with your business",
    benefits: ["Rapid deployment", "Pay-as-you-grow pricing", "Expert technical guidance", "Production-ready from day one"],
    image: "https://images.pexels.com/photos/36733304/pexels-photo-36733304.jpeg"
  },
  {
    id: 2,
    title: "For Enterprises",
    description: "Secure, compliant infrastructure built for mission-critical operations",
    benefits: ["Enterprise security", "Compliance certified", "Dedicated support", "Custom SLA agreements"],
    image: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a"
  },
  {
    id: 3,
    title: "For SaaS Platforms",
    description: "High-availability architecture engineered for 24/7 operations",
    benefits: ["99.99% uptime", "Global CDN", "Auto-scaling", "Real-time monitoring"],
    image: "https://images.unsplash.com/photo-1573164713988-8665fc963095"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "CTO, TechVision Inc.",
    content: "Reverential Consultants transformed our infrastructure. The migration was seamless, and we've seen a 40% reduction in operational costs while improving performance.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Engineering Director, DataFlow Solutions",
    content: "Their expertise in cloud architecture is unmatched. The team delivered a scalable solution that has handled our 10x growth effortlessly.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Founder, CloudStart",
    content: "As a startup, we needed infrastructure that could scale. Reverential gave us enterprise-grade solutions with startup-friendly pricing and support.",
    rating: 5
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "The Future of Multi-Cloud Architecture in 2025",
    excerpt: "Explore how multi-cloud strategies are reshaping enterprise infrastructure and enabling unprecedented flexibility and resilience.",
    author: "Dr. Rajesh Kumar",
    date: "2025-01-15",
    category: "Cloud Strategy",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1771189956746-e96f8bf77d42"
  },
  {
    id: 2,
    title: "DevOps Best Practices: Automating Your Infrastructure",
    excerpt: "Learn how Infrastructure as Code and CI/CD pipelines can reduce deployment time by 75% while improving reliability.",
    author: "Sarah Mitchell",
    date: "2025-01-10",
    category: "DevOps",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1573757056004-065ad36e2cf4"
  },
  {
    id: 3,
    title: "Zero-Trust Security: Protecting Cloud Infrastructure",
    excerpt: "Understanding zero-trust architecture and implementing robust security measures for your cloud environment.",
    author: "James Park",
    date: "2025-01-05",
    category: "Security",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1775185172785-4bbd6b0fc8f5"
  },
  {
    id: 4,
    title: "Optimizing Cloud Costs Without Sacrificing Performance",
    excerpt: "Practical strategies for reducing cloud spending while maintaining or improving application performance and reliability.",
    author: "Dr. Rajesh Kumar",
    date: "2024-12-28",
    category: "Cost Optimization",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1771189957040-3a4f9b78812c"
  }
];

export const aboutData = {
  mission: "To empower businesses globally with scalable, secure, and high-performance cloud infrastructure that drives digital transformation and sustainable growth.",
  vision: "To be the world's most trusted partner in cloud innovation, setting the standard for reliability, performance, and technical excellence.",
  values: [
    { title: "Excellence", description: "We deliver nothing less than exceptional solutions and service." },
    { title: "Innovation", description: "We stay ahead of technology trends to provide cutting-edge solutions." },
    { title: "Integrity", description: "We build trust through transparency, honesty, and ethical practices." },
    { title: "Partnership", description: "We succeed when our clients succeed, making their goals our priority." }
  ],
  stats: [
    { label: "Years of Expertise", value: "12+" },
    { label: "Countries Served", value: "45+" },
    { label: "Petabytes Managed", value: "2000+" }
  ],
  image: "https://images.unsplash.com/photo-1541746972996-4e0b0f43e02a"
};

export const contactFormSubmit = (formData) => {
  // Mock form submission
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Form submitted:', formData);
      resolve({ success: true, message: 'Thank you for reaching out! Our team will contact you within 24 hours.' });
    }, 1000);
  });
};